export default "__VITE_ASSET__DvXev2k6__"